const routes = [
  {
    match: '/manage/videos/([\\w-]+)',
    route: '/manage/videos/:clipId',
  },
  {
    match: '/upload/videos/([\\w-]+)',
    route: '/upload/videos/:uploadId',
  },
  {
    match: '/upload/videos',
    route: '/upload/videos',
  },
];

export function matchPathToRoute(path: string) {
  const match = routes.find((r) => path.match(r.match));
  return match ? match.route : null;
}
